module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-ons-page', {
    attrs: {
      "modifier": "secondary"
    }
  }, [_c('v-ons-button', {
    attrs: {
      "modifier": "light back"
    },
    on: {
      "click": _vm.backToTop
    }
  }, [_vm._v("\n    TOPに戻る\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('ul', {
    staticClass: "link_list"
  }, _vm._l((_vm.linkList), function(link, index) {
    return _c('li', {
      key: index,
      staticClass: "link_button",
      attrs: {
        "href": "#"
      }
    }, [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          return _vm.goToNext(link.page)
        }
      }
    }, [_vm._v("\n          " + _vm._s(link.name) + "\n        ")])])
  }), 0)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49a1dc48","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/private/index.vue
// module id = 558
// module chunks = 0